import "./About.css";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { FaInstagram } from "react-icons/fa6";
import { FaFacebook } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";
import { Link } from "react-router-dom";
import Carousel from "react-bootstrap/Carousel";

const About = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const [hoverText0, setHoverText0] = useState("MEET THE MAKER");
  const [hoverText1, setHoverText1] = useState("KAIPI MARIA");
  const [hoverText2, setHoverText2] = useState("25 year old self-taught artist");
  const [hoverText3, setHoverText3] = useState(
    "Kaipi Maria resides and works from her home in the picturesque town of Patras, Greece. A self-taught artist who started painting and sketching for fun at a very young age, she has progressed over the years, evolving her techniques, discovering new ones, and challenging herself through continuous development."
  );
  const [hoverText4, setHoverText4] = useState("ARGYRI'S MARKET EXHIBITION IN PATRAS 2022");
  const [hoverText5, setHoverText5] = useState("ARGYRI'S MARKET EXHIBITION IN PATRAS 2024");
  const [hoverText6, setHoverText6] = useState("The paintings");

  const handleHover = (setText, text) => () => setText(text);

  // Carousel
  const [index, setIndex] = useState(0);
  const handleSelect = (i) => setIndex(i);

  // Hide circle on scroll; add/remove listener safely
  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById("circle");
      if (el) el.style.visibility = "hidden";
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleMouseMove = (e) => {
    const { clientX, clientY } = e;
    const el = document.getElementById("circle");
    setPosition({ x: clientX, y: clientY + window.scrollY });
    if (el) el.style.visibility = "visible";
  };

  // Reveal on scroll
  const revealRef = useRef(null);
  useEffect(() => {
    const root = revealRef.current;
    if (!root) return;

    const els = Array.from(root.querySelectorAll("[data-reveal]"));
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("is-visible");
        });
      },
      { threshold: 0.12 }
    );

    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="about-page" onMouseMove={handleMouseMove} ref={revealRef}>
      {/* hover circle */}
      <div
        className="circle"
        id="circle"
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`,
          width: "200px",
          height: "200px",
          visibility: "hidden",
        }}
      />

      {/* Header (keep your existing nav, but add section quick-jumps) */}
      <div className="d-flex justify-content-center">
        <div className="headerContainer pt-5 pr-5 pl-5 w-100">
          <div className="logoContainer">
            <h1 className="logo">KAIPI MARIA</h1>
          </div>

          <div className="d-flex menuBar">
            <Link to={"/"} className="nav-item nav-link" id="homeBtn">
              Home
            </Link>
            <Link to={"/Gallery"} className="nav-item nav-link" id="Gallery">
              Gallery
            </Link>
            <Link
              to={"/AboutMe"}
              className="nav-item nav-link active"
              id="AboutMeBtn"
              style={{ textDecoration: "underline" }}
            >
              AboutMe
            </Link>
            <Link to={"/Contact"} className="nav-item nav-link" id="ContactBtn">
              Contact
            </Link>
            <Link to={"/Shop"} className="nav-item nav-link" id="ShopBtn">
              Shop
            </Link>
          </div>

          
          </div>
      </div>

      {/* Scroll container (snap feel) */}
      <main className="about-scroll">
        {/* INTRO */}
        <section id="intro" className="about-section about-section--hero">
          <div className="about-container">
            <div className="about-card about-hero-card" data-reveal>
              <div className="row g-4 align-items-start">
                <div className="col-12 col-lg-8">
                  <div className="about-kicker"
                    onMouseEnter={handleHover(setHoverText0, "ΓΝΩΡΙΣΤΕ ΤΟΝ ΔΗΜΙΟΥΡΓΟ")}
                    onMouseLeave={handleHover(setHoverText0, "MEET THE MAKER")}
                  >
                    {hoverText0}
                  </div>

                  <h2
                    className="about-title"
                    onMouseEnter={handleHover(setHoverText1, "ΚΑΪΠΗ ΜΑΡΙΑ")}
                    onMouseLeave={handleHover(setHoverText1, "KAIPI MARIA")}
                  >
                    {hoverText1}
                  </h2>

                  <div
                    className="about-subtitle"
                    onMouseEnter={handleHover(setHoverText2, "25 χρονών αυτοδίδακτη καλλιτέχνης")}
                    onMouseLeave={handleHover(setHoverText2, "25 year old self-taught artist")}
                  >
                    {hoverText2}
                  </div>

                  <p
                    className="about-paragraph"
                    onMouseEnter={handleHover(
                      setHoverText3,
                      "Η Καΐπη Μαρία κατοικεί και εργάζεται από το σπίτι της στην γραφική πόλη της Πάτρας, Ελλάδα. Αυτοδίδακτη καλλιτέχνης που ξεκίνησε να ζωγραφίζει και να σχεδιάζει για διασκέδαση σε πολύ νεαρή ηλικία, έχει εξελιχθεί με τα χρόνια, εξελίσσοντας τις τεχνικές της, ανακαλύπτοντας καινούριες και προκαλώντας τον εαυτό της μέσα από μια συνεχή εξέλιξη."
                    )}
                    onMouseLeave={handleHover(
                      setHoverText3,
                      "Kaipi Maria resides and works from her home in the picturesque town of Patras, Greece. A self-taught artist who started painting and sketching for fun at a very young age, she has progressed over the years, evolving her techniques, discovering new ones, and challenging herself through continuous development."
                    )}
                  >
                    {hoverText3}
                  </p>
                </div>

                <div className="col-12 col-lg-4">
                  <div className="about-media" data-reveal>
                    <img
                      className="img-fluid about-img"
                      src="/images/Gallery/rizospastikhprotashmodas.jpg"
                      alt="Exhibit"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="about-scrollhint">Scroll</div>
        </section>

        {/* 2024 */}
        <section id="ex2024" className="about-section about-section--light">
          <div className="about-container">
            <div className="about-card" data-reveal>
              <h3
                className="section-heading text-center"
                onMouseEnter={handleHover(setHoverText5, "ΕΚΘΕΣΗ ΣΤΗΝ ΑΓΟΡΑ ΑΡΓΥΡΗ 2024")}
                onMouseLeave={handleHover(setHoverText5, "ARGYRI'S MARKET EXHIBITION IN PATRAS 2024")}
              >
                {hoverText5}
              </h3>

              <div className="row g-4 align-items-start mt-2">
                <div className="col-12 col-lg-6">
                  <div className="about-media" data-reveal>
                    <img className="img-fluid about-img" src="/images/Gallery/Ekthesi2024.jpg" alt="Exhibition 2024" />
                  </div>
                </div>

                <div className="col-12 col-lg-6">
                  <div className="about-media" data-reveal>
                    <Carousel activeIndex={index} onSelect={handleSelect} interval={4000} pause="hover">
                      <Carousel.Item>
                        <img className="d-block w-100 about-img" src="/images/Gallery/Ekthesi2024_1.jpg" alt="2024-1" />
                      </Carousel.Item>
                      <Carousel.Item>
                        <img className="d-block w-100 about-img" src="/images/Gallery/Ekthesi2024_2.jpg" alt="2024-2" />
                      </Carousel.Item>
                      <Carousel.Item>
                        <img className="d-block w-100 about-img" src="/images/Gallery/Ekthesi2024_3.jpg" alt="2024-3" />
                      </Carousel.Item>
                    </Carousel>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Paintings */}
        <section id="paintings" className="about-section about-section--dark">
          <div className="about-container">
            <div className="about-card about-card--dark" data-reveal>
              <h3
                className="section-heading text-center"
                onMouseEnter={handleHover(setHoverText6, "Οι πίνακες")}
                onMouseLeave={handleHover(setHoverText6, "The paintings")}
              >
                {hoverText6}
              </h3>

              <div className="row g-4 mt-2">
                <div className="col-12 col-md-4">
                  <div className="art-card" data-reveal>
                    <img className="img-fluid about-img" src="/images/Gallery/Ekthesi2024_1.1.jpg" alt="Angel" />
                    <div className="mt-3 big-text text-center">Angel, 65x90cm acrylic on canvas</div>
                  </div>
                </div>

                <div className="col-12 col-md-4">
                  <div className="art-card" data-reveal>
                    <img className="img-fluid about-img" src="/images/Gallery/Ekthesi2024_1.2.jpg" alt="Figures" />
                    <div className="mt-3 big-text text-center">Figures, 50x70cm acrylic on canvas</div>
                  </div>
                </div>

                <div className="col-12 col-md-4">
                  <div className="art-card" data-reveal>
                    <img className="img-fluid about-img" src="/images/Gallery/Ekthesi2024_1.3.jpg" alt="Feminine Urge" />
                    <div className="mt-3 big-text text-center">Feminine Urge, 65x90cm acrylic on canvas</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 2022 */}
        <section id="ex2022" className="about-section about-section--light">
          <div className="about-container">
            <div className="about-card" data-reveal>
              <h3
                className="section-heading text-center"
                onMouseEnter={handleHover(setHoverText4, "ΕΚΘΕΣΗ ΣΤΗΝ ΑΓΟΡΑ ΑΡΓΥΡΗ 2022")}
                onMouseLeave={handleHover(setHoverText4, "ARGYRI'S MARKET EXHIBITION IN PATRAS 2022")}
              >
                {hoverText4}
              </h3>

              <div className="row g-4 mt-2">
                <div className="col-12 col-md-4">
                  <div className="about-media" data-reveal>
                    <img className="img-fluid about-img" src="/images/Gallery/ekthesh.jpg" alt="2022-1" />
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="about-media" data-reveal>
                    <img className="img-fluid about-img" src="/images/Gallery/elegance_ekthesh.jpg" alt="2022-2" />
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="about-media" data-reveal>
                    <img className="img-fluid about-img" src="/images/Gallery/neraida_ekthesh.jpg" alt="2022-3" />
                  </div>
                </div>
              </div>
            </div>

            {/* Social */}
            <div className="about-social" data-reveal>
              <a href="https://www.instagram.com/kaipimaria_art/" className="socialIcons" aria-label="Instagram">
                <FaInstagram size={30} />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=100012918557813"
                className="socialIcons"
                aria-label="Facebook"
              >
                <FaFacebook size={30} />
              </a>
              <a href="mailto:kaiphmaria001@gmail.com" className="socialIcons" aria-label="Email">
                <MdOutlineEmail size={30} />
              </a>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default About;
